import { useState, useEffect } from 'react';

export const useActiveProjectsEvents = (defaultTab = 'Projects', storageKey = 'projectsEventsTab') => {
    const [activeTab, setActiveTab] = useState(() => {
        // Try to get the saved tab from localStorage
        const savedTab = localStorage.getItem(storageKey);
        return savedTab || defaultTab;
    });

    // Save to localStorage whenever activeTab changes
    useEffect(() => {
        localStorage.setItem(storageKey, activeTab);
    }, [activeTab, storageKey]);

    const handleActiveTab = (active) => {
        setActiveTab(active);
    };

    return [activeTab, handleActiveTab];
}; 